import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {RootState} from "@/store/Store";

export interface RolesSliceInterface {
    formVisible: boolean,
    formVariant: "new" | "edit",
    editId: string,
    editTitle: string,
    editAlias: string,
    editIsActive: 0 | 1,
    deleteModalVisible: boolean,
    deleteId: string,
    deleteTitle: string,
}

function getInitialState(): RolesSliceInterface {
    return {
        formVisible: false,
        formVariant: "new",
        editId: "",
        editTitle: "",
        editAlias: "",
        editIsActive: 1,
        deleteId: "",
        deleteTitle: "",
        deleteModalVisible: false,
    }
}

export const RolesSlice = createSlice({
    name: "RolesSlice",
    initialState: getInitialState(),
    reducers: {
        reset: () => {
            return getInitialState()
        },
        updateFields: (state, action: PayloadAction<Partial<RolesSliceInterface>>) => {
            Object.assign(state, action.payload)
        }
    },
});

export const {
    reset,
    updateFields
} = RolesSlice.actions;

export const RolesSelectors = {
    formVisible: (state: RootState) => state.roles.formVisible,
    formVariant: (state: RootState) => state.roles.formVariant,
    editId: (state: RootState) => state.roles.editId,
    editTitle: (state: RootState) => state.roles.editTitle,
    editAlias: (state: RootState) => state.roles.editAlias,
    editIsActive: (state: RootState) => state.roles.editIsActive,
    deleteModalVisible: (state: RootState) => state.roles.deleteModalVisible,
    deleteId: (state: RootState) => state.roles.deleteId,
    deleteTitle: (state: RootState) => state.roles.deleteTitle,
}

export const RolesReducer = RolesSlice.reducer;
